import { render, staticRenderFns } from "./ChapterBox.vue?vue&type=template&id=205c6d06"
import script from "./ChapterBox.vue?vue&type=script&lang=js"
export * from "./ChapterBox.vue?vue&type=script&lang=js"
import style0 from "./ChapterBox.vue?vue&type=style&index=0&id=205c6d06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports